import filter from '../modules/faqFilter';
import openCategory from '../modules/openCategory';
import collapse from '../modules/collapse';

filter();
openCategory('.categoryFaq__title', '.categoryFaq__list');
collapse();